
import { getContent } from '../store/ContentStore';

export const loadTermsContentEn = () => {
    const termsData = getContent("terms.", "en");

    if (!termsData || !termsData.en || Object.keys(termsData.en).length === 0) {
        return { terms: [] };
    }

    const englishLabels = termsData.en;
    const groupedItems = {};

    Object.entries(englishLabels).forEach(([key, value]) => {
        const match = key.match(/^terms\.(item\d+)\.(.+)$/);
        if (match) {
            const [, itemKey, field] = match;
            if (!groupedItems[itemKey]) groupedItems[itemKey] = {};
            groupedItems[itemKey][field] = value;
        }
    });

    const termsArray = Object.keys(groupedItems).map(itemKey => {
        const item = groupedItems[itemKey];
        const descriptions = Object.keys(item)
            .filter(k => k.startsWith('description'))
            .map(k => item[k])
            .filter(desc => desc && desc.trim() !== '');

        if (item.description) descriptions.unshift(item.description);

        return {
            key: itemKey,
            title: item.title || '',
            descriptions
        };
    });

    return { terms: termsArray };
};


export const loadTermsContentRo = () => {
    const termsData = getContent("terms.", "ro");

    if (!termsData || !termsData.ro || Object.keys(termsData.ro).length === 0) {
        return { terms: [] };
    }

    const romanianLabels = termsData.ro;
    const groupedItems = {};

    Object.entries(romanianLabels).forEach(([key, value]) => {
        const match = key.match(/^terms\.(item\d+)\.(.+)$/);
        if (match) {
            const [, itemKey, field] = match;
            if (!groupedItems[itemKey]) groupedItems[itemKey] = {};
            groupedItems[itemKey][field] = value;
        }
    });

    const termsArray = Object.keys(groupedItems).map(itemKey => {
        const item = groupedItems[itemKey];
        const descriptions = Object.keys(item)
            .filter(k => k.startsWith('description'))
            .map(k => item[k])
            .filter(desc => desc && desc.trim() !== '');

        if (item.description) descriptions.unshift(item.description);

        return {
            key: itemKey,
            title: item.title || '',
            descriptions
        };
    });

    return { terms: termsArray };
};
